import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from 'react';
import { getAvailableYears } from '../requests/public.request';
import { useKato } from './kato.context';

type FullscreenState = {
  open: boolean;
  type: string | null;
};

type SharedContextType = {
  fullscreen: FullscreenState;
  setFullscreen: React.Dispatch<React.SetStateAction<FullscreenState>>;
  selectedInfoYear: number;
  setSelectedInfoYear: React.Dispatch<React.SetStateAction<number>>;
  years: number[];
};

const defaultFullscreen: FullscreenState = {
  open: false,
  type: null,
};

const SharedContext = createContext<SharedContextType | undefined>(undefined);

export const SharedProvider = ({ children }: { children: ReactNode }) => {
  const [fullscreen, setFullscreen] =
    useState<FullscreenState>(defaultFullscreen);
  const [selectedInfoYear, setSelectedInfoYear] = useState<number>(2026);
  const [years, setYears] = useState<number[]>([]);
  const { getCurrentKato } = useKato();
  const current = getCurrentKato();

  useEffect(() => {
    current?.kato &&
      getAvailableYears(current?.kato).then((res) => {
        setYears(res.list);
        setSelectedInfoYear(res.list[0]);
      });
  }, []);

  return (
    <SharedContext.Provider
      value={{
        fullscreen,
        setFullscreen,
        selectedInfoYear,
        setSelectedInfoYear,
        years,
      }}
    >
      {children}
    </SharedContext.Provider>
  );
};

export const useShared = () => {
  const context = useContext(SharedContext);
  if (!context) {
    throw new Error('useShared must be used within a SharedProvider');
  }
  return context;
};
